<template>
  <v-col class="d-flex flex-column fill-height" cols="12" lg="8">
    <ViewContainer compact-width>
      <h1 class="text-left">Personal Information</h1>
      <div class="text-left">Manage your profile</div>

      <v-divider class="my-7" />

      <v-row>
        <v-col class="text-left" cols="12" sm="8" md="6">
          <PInputField label="Email" :value="userProfile.email" readonly />
        </v-col>
        <v-col class="text-left" cols="12" sm="8" md="6">
          <PInputField
            label="Name"
            :value="userProfile.name"
            @update-event="updateName"
          />
        </v-col>
      </v-row>

      <v-divider class="mb-4" />
      <div class="d-flex">
        <v-spacer></v-spacer>
        <PSecondaryButton :disabled="isLoading || !hasChange" @click="load"
          >Cancel</PSecondaryButton
        >
        <PPrimaryButton
          class="ml-1"
          :disabled="isLoading || !hasChange"
          :loading="isLoading"
          @click="save"
          >Save</PPrimaryButton
        >
      </div>
    </ViewContainer>
  </v-col>
</template>

<script setup lang="ts">
import PInputField from "@/components/custom/PInputField.vue";
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import PSecondaryButton from "@/components/custom/buttons/PSecondaryButton.vue";
import ViewContainer from "@/components/containers/ViewContainer.vue";
import { UserProfile } from "@/models/userProfile";
import {
  getUserProfile,
  updateUserProfile,
} from "@/services/userProfileService";
import { onBeforeMount, ref } from "vue";
import { useUserProfileStore } from "@/stores/userProfileStore";

const userProfileStore = useUserProfileStore();

const userProfile = ref(new UserProfile());
const isLoading = ref(false);
const hasChange = ref(false);

onBeforeMount(() => {
  userProfile.value = userProfileStore.userProfile;
});

async function load(): Promise<void> {
  isLoading.value = true;
  userProfile.value = await getUserProfile();
  isLoading.value = false;
  hasChange.value = false;
}

async function save(): Promise<void> {
  isLoading.value = true;
  userProfileStore.userProfile = await updateUserProfile(userProfile.value);
  userProfile.value = userProfileStore.userProfile;
  isLoading.value = false;
  hasChange.value = false;
}

function updateName(name: string): void {
  userProfile.value.name = name;
  hasChange.value = true;
}
</script>
